
import { mapState, mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import SessionDetails from "./SessionDetails.vue";
import ParentSession from "../../models/ParentSession";
import Session from "@/models/Session";

@Component({
  components: {
    SessionDetails
  },
  computed: {
    ...mapState("EventRegistration", [
      "loadingSessions",
      "sessions",
      "parentSessions",
      "filterdParentSessions",
      "studies",
      "SessionsFullyLoaded",
      "loadingError",
      "loadingMessage"
    ]),
    ...mapGetters("EventRegistration", [
      "Event",
      "parentSessionsByName",
      "FilteredSessions",
      "CurrentNumberOfPages",
      "VlsSessions",
      "IsVlsSession"
    ])
  }
})
export default class SessionList extends Vue {
  parentSessionsPerpage = [];
  page = 1;
  totalvisible = 8;
  mobile = false;
  windowWidth = 2000;

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
      this.mobile = this.windowWidth < 700;
    }
  }
  created() {
    this.page = 1;
    if (this.windowWidth < 700) {
      this.totalvisible = 4;
    }
  }

  data() {
    return {
      windowWidth: window.innerWidth,
      panel: 0,
      panel2: [99],
      page: 1,
      total: 0,
      pages: this.$store.state.EventRegistration.filterdParentSessions,
      visible: 6
    };
  }

  OnlyName() {
    if (this.$store.state.EventRegistration.event) {
      switch (this.$store.state.EventRegistration.event.eventtype) {
        case "806970011":
        case "806970013":
        case "806970014":
        case "806970015":
        case "806970016":
          return true;
        default:
          return false;
      }
    }
  }

  getLanguages(ps: ParentSession) {
    const languages = [];

    if (ps.engels == "true") languages.push(this.$tc("er.EN"));
    if (ps.nederlands == "true") languages.push(this.$tc("er.NL"));
    if (ps.duits == "true") languages.push(this.$tc("er.DE"));

    if (languages.length > 0) return "(" + languages.join() + ")";
    else return "";
  }

  @Watch("page")
  pageChange(pagenr: number) {
    const parentsessions = this.$store.state.EventRegistration.filterdParentSessions;
    const start = (pagenr - 1) * this.$store.state.EventRegistration.sessionsOnPage;
    const end = start + this.$store.state.EventRegistration.sessionsOnPage;
    this.parentSessionsPerpage = parentsessions.slice(start, end);
  }

  @Watch("filterdParentSessions", { immediate: true })
  filterdParentSessionsChanged() {
    this.page = 1;
    this.pageChange(1);
  }
}
